import { Flex, Typography } from '@iheartjane/reefer';
import { Form, useFormContext } from '@iheartjane/reefer-hook-form';
import { formatCurrency } from '@iheartjane/utils';

export const RequiredFields = ({ disabled }: { disabled: boolean }) => {
  const { getValues, setValue, watch } = useFormContext();
  const specialType = watch('special_type');
  const isSpendingThreshold = specialType === 'spending_threshold';
  const specialTypeSettings = isSpendingThreshold
    ? specialType
    : `${specialType}.settings`;
  const thresholdField = isSpendingThreshold
    ? 'cart_threshold'
    : 'threshold_number_of_items_in_cart';
  const fullThresholdField = `display.${specialType}.${thresholdField}`;
  const thresholdValue = getValues(fullThresholdField);
  const fieldLabel = isSpendingThreshold
    ? 'Minimum spend'
    : 'Minimum products requirement';

  return (
    <Flex flexDirection="column" gap={24} mt={24}>
      {!disabled ? (
        <Form.NumberField
          name={fullThresholdField}
          label={fieldLabel}
          defaultValue={thresholdValue}
          min={1}
          step={isSpendingThreshold ? 0.01 : 1}
          required
          disableOnWheel
          {...(isSpendingThreshold && {
            allowedDecimalPlaces: 2,
            startUnit: '$',
          })}
        />
      ) : (
        <Flex width="50%" flexDirection="column">
          <Typography
            color="grays-black"
            variant="body-semibold"
            data-testid="non-janepos-synced-required"
          >
            {fieldLabel}
          </Typography>
          <Typography color="grays-black" mt={4}>
            {isSpendingThreshold
              ? formatCurrency(thresholdValue)
              : thresholdValue || 'N/A'}
          </Typography>
        </Flex>
      )}
      <Flex flexDirection="column" gap={12}>
        <Typography variant="body-semibold">
          Discount required products
        </Typography>
        <Form.CheckboxField
          name={`display.${specialTypeSettings}.allow_discounts_on_required_products`}
          label="Also apply discount to required products"
          disabled={disabled}
          onChange={(value) =>
            setValue(
              `display.${specialTypeSettings}.copy_conditions_for_discounted_products`,
              value
            )
          }
        />
      </Flex>
      <Flex flexDirection="column" gap={12}>
        <Typography variant="body-semibold">
          Exclude required products from other specials
        </Typography>
        <Form.CheckboxField
          name={`display.${specialTypeSettings}.exclude_product_specials_from_bundle_qualifiers`}
          label="Prevent required products from being discounted by Product deals"
          disabled={disabled}
        />
      </Flex>
    </Flex>
  );
};
